<template>
  <div class="container">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell is-link @click="chooseCampus">
            <template #title>
              <span>校区</span>
              <span v-if="params.campusIds.length" style="color: var(--g6); font-size: 12px">
                已选<span style="color: var(--c1)">{{ params.campusIds.length }}</span>
              </span>
            </template>
          </van-cell>
          <div class="nav-wrapper">
            <div class="nav-title flex-between">
              <span>积分抵扣</span>
              <van-checkbox v-model="pointChecked" icon-size="16px">只看可积分抵扣的商品</van-checkbox>
            </div>
          </div>        
        </div>
        <van-row class="footer" gutter="8">
          <van-col span="12">
            <van-button block square round hairline @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm"> 确认 </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
let defaultParams = {
  campusIds: [],
  campusList: [],
  enableMemberPoint: null,
}

export default {
  data() {
    return {
      visible: false,
      config: {
        mallCompany: '',
        mallCompanyList: [],
      },
      params: JSON.parse(JSON.stringify(defaultParams)),
    }
  },
  computed: {
    pointChecked: {
      get() {
        return !!this.params.enableMemberPoint;
      },
      set(val) {
        if (val) {
          this.params.enableMemberPoint = 1;
        } else {
          this.params.enableMemberPoint = null;
        }
      },
    },
    
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.config) {
          this.config = Object.assign(this.config, opts.config);
        }
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
          console.log(opts.params)
          console.log(this.params)
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
        api: this.config.mallCompanyList ? this.$api.queryCampus : this.$api.getCampusList,
        params: {
          companyId: this.config.mallCompany,
          type: 1,
        },
      });

      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      // 如果选中的校区发生变化
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;
      }
    },
  
    reset() {
      this.params = JSON.parse(JSON.stringify(defaultParams));
    },
    doneAnima() {
      this.$router.back();
      return new Promise(rsv => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: this.params,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
    this.calendarMinDate = new Date(
      this.calendarMinDate.setYear(this.calendarMinDate.getFullYear() - 5)
    );
    this.calendarMaxDate = new Date(
      this.calendarMaxDate.setYear(this.calendarMaxDate.getFullYear() + 1)
    );
  },
  watch: {
    "$vxRoute.vx_action": function (nv, ov) {
      if (nv == "vx-out") {
        this.visible = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .nav-wrapper {
        padding: 0 calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 8) calc(var(--gap) * 17) calc(var(--gap) * 8) 0;
          color: var(--g7);
          // font-size: var(--fs-lg);
        }
        .time-input {
          width: calc(var(--w) * 82);
          height: calc(var(--w) * 36);
          border: 1px solid var(--g4);
          border-radius: var(--radius-base);
          padding: 0 calc(var(--gap) * 10);
          background: var(--white);
        }
      }
      .three-a-row {
        .nav-title {
          padding: calc(var(--gap) * 8) calc(var(--gap) * 17) calc(var(--gap) * 1)
            calc(var(--gap) * 16);
          color: var(--g7);
          // font-size: var(--fs-lg);
        }
        .nav-div {
          display: flex;
          flex-wrap: wrap;
          margin: calc(var(--gap) * 8);
          padding-bottom: calc(var(--gap) * 8);
        }
        .nav-box {
          width: 33.33%;
          padding: calc(var(--gap) * 8);
          .item-nav {
            height: calc(var(--w) * 32);
            line-height: calc(var(--w) * 32);
            text-align: center;
            border-radius: var(--radius-md);
            background-color: var(--g1);
            &.active {
              color: var(--c1);
              background-color: rgba(var(--c1-rgb), 0.19);
            }
          }
        }
      }
      .time-input-div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(var(--w) * 36);
        border-radius: var(--radius-base);
        border: 1px solid var(--g4);
        color: var(--g5);
        &.has-value {
          color: var(--g8);
        }
      }
    }
  }
}
</style>